import { defaultUnitsForRegion, ftToM, pricePerUnitValue, type Units } from '@better-lights/core';

/**
 * Web glue for docs/spec/09 units (formatting and parsing are core-ts: formatLength,
 * formatSpacing, formatWash, formatFrameWidth, formatPricePerUnit, parseLength, …).
 */

/** Default units from the browser's locale region (imperial for US, LR, MM). */
export function defaultUnits(locale = typeof navigator !== 'undefined' ? navigator.language : 'en-US'): Units {
  let region: string | undefined;
  try {
    region = new Intl.Locale(locale).maximize().region;
  } catch {
    region = undefined;
  }
  return defaultUnitsForRegion(region ?? locale);
}

/** Main length unit label: "ft" / "m". */
export const lengthUnit = (u: Units) => (u === 'metric' ? 'm' : 'ft');

/** Text for a price input in the chosen units, rounded to the cent ($90/m shows "90", not 89.99…). */
export function priceInputText(pricePerFt: number | null | undefined, u: Units): string {
  if (pricePerFt == null) return '';
  return String(Math.round(pricePerUnitValue(pricePerFt, u) * 100) / 100);
}

/** Text for a length input in the chosen units (feet integer-ish, metres to 0.1). */
export function lengthInputText(ft: number | null | undefined, u: Units): string {
  if (ft == null) return '';
  return u === 'metric' ? String(Math.round(ftToM(ft) * 10) / 10) : String(Math.round(ft * 10) / 10);
}
